var map = {
	"./AKanban.svg": 197,
	"./Agile.svg": 198,
	"./Analysis.svg": 199,
	"./Analytic.svg": 200,
	"./Appreciation.svg": 201,
	"./Bill.svg": 202,
	"./Brief Project.svg": 203,
	"./Coaching.svg": 204,
	"./Collaboration.svg": 205,
	"./Contract.svg": 206,
	"./Creativity.svg": 207,
	"./Deployment.svg": 208,
	"./File Security.svg": 209,
	"./Guide Book.svg": 210,
	"./ID card.svg": 211,
	"./Innovative.svg": 212,
	"./List.svg": 213,
	"./Manager.svg": 214,
	"./Message.svg": 215,
	"./Production.svg": 216,
	"./Profile.svg": 217,
	"./Schedule.svg": 218,
	"./Skill.svg": 219,
	"./Sprint.svg": 220,
	"./Task flow.svg": 221,
	"./Team Brainstorming.svg": 222,
	"./Time Management.svg": 223,
	"./Workflow.svg": 224
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 196;